import { ContactInfoWebViewComponent } from './webviews/my-wehicles-web-view/contact-info-web-view/contact-info-web-view.component';
import { MyWehiclesWebViewComponent } from './webviews/my-wehicles-web-view/my-wehicles-web-view.component';
import { ResetPinSuccessComponent } from './app-sub-component/reset-pin-success/reset-pin-success.component';
import { ResetPinComponentComponent } from './app-sub-component/reset-pin-component/reset-pin-component.component';
import { AppSubComponentComponent } from './app-sub-component/app-sub-component.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcuraLinkComponent } from './acura-link/acura-link.component';
import { FaqsComponent } from './faqs/faqs.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { MyvehiclesComponent } from './my-vehicle/myvehicles/myvehicles.component';
import { OwnersComponent } from './owners/owners.component';
import { PaymentComponent } from './payment/payment.component';
import { ProfileComponent } from './profile/profile.component';
import { AuthGuard } from './auth.guard';
import { IviAuthGuard } from './ivi.auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { IviMy23BaseComponent } from './ivi-my23/ivi-my23-base/ivi-my23-base.component';
import { Ivi23authGuard } from './ivi-my23/ivi23auth.guard';


const routes: Routes = [
  {
    path: '', canActivate: [AuthGuard],
    loadChildren: () =>
      import('./my-vehicle/my-vehicle.routing.module').then(
        (m) => m.MyVehicleModuleRoutingModule
      ),
  },
  { path: 'acuraLink', canActivate: [AuthGuard], component: AcuraLinkComponent },
  { path: 'owners', canActivate: [AuthGuard], component: OwnersComponent },
  { path: 'faqs', canActivate: [AuthGuard], component: FaqsComponent },
  { path: 'myAccount', canActivate: [AuthGuard], component: MyAccountComponent },
  { path: 'resetPin', canActivate: [AuthGuard], component: ResetPinComponentComponent },
  { path: 'resetPinSuccess', canActivate: [AuthGuard], component: ResetPinSuccessComponent },
  {
    path: 'subscriptionWV',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./webviews/webviews-routing/webviews-routing.module').then(
        (m) => m.WebviewsRoutingModule
      ),
  },
  // GDO Path
  {
    path: 'gdo', canActivate: [AuthGuard],
    loadChildren: () =>
      import('./gdo/gdo-desktop/gdo-desktop-routing.module').then(
        (m) => m.GdoDesktopRoutingModule
      ),
  },
  // GDO Webview Path
  {
    path: 'gdoWV', //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./gdo/gdo-webview/gdo-webview-routing.module').then(
        (m) => m.GdoWebviewRoutingModule
      ),
  },
  {
    path: 'RefreshComponent',
    canActivate: [AuthGuard],
    data: { routePurpose: 'gdo-webview-refresh-alias' },
    loadChildren: () =>
      import('./gdo/gdo-webview/gdo-webview-routing.module').then(
        (m) => m.GdoWebviewRoutingModule
      ),
  },
  {
    path: 'subscriptionRefreshComponent',
    canActivate: [AuthGuard],
    data: { routePurpose: 'subscription-webview-refresh-alias' },
    loadChildren: () =>
      import('./webviews/webviews-routing/webviews-routing.module').then(
        (m) => m.WebviewsRoutingModule
      ),
  },
 
  { path: 'contact-info-wv', canActivate: [AuthGuard], component: ContactInfoWebViewComponent },
  { path: 'profile', canActivate: [AuthGuard], component: ProfileComponent },
  {
    path: 'payment', canActivate: [AuthGuard],
    loadChildren: () =>
      import('./payment/payment-routing/payment-routing-routing.module').then(
        (m) => m.PaymentRoutingRoutingModule
      ),
  },
  {
    path: 'subscription', canActivate: [AuthGuard],
    loadChildren: () =>
      import('./my-vehicle/my-vehicle.routing.module').then(
        (m) => m.MyVehicleModuleRoutingModule
      ),
  },
  {
    path: 'myvehicle', canActivate: [AuthGuard],
    loadChildren: () =>
      import('./my-vehicle/my-vehicle.routing.module').then(
        (m) => m.MyVehicleModuleRoutingModule
      ),
  },
  {
    path: 'ivi/my23',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./ivi-my23/ivi-my23-routing.module').then(
        (m) => m.IviMy23RoutingModule
      ),
  },
  { path: "not-found", component: NotFoundComponent }, // change this to page not found
  {
    path: 'ivi',
    canActivate: [IviAuthGuard],
    loadChildren: () =>
      import('./ivi/ivi.routing.module').then(
        (m) => m.IviRoutingModule
      ),
  },
  {
    path: 'shared',
    canActivate: [IviAuthGuard],
    loadChildren: () =>
      import('./shared/shared-routing.module').then(
        (m) => m.SharedRoutingModule
      ),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }

export const routingComponents = [
  AcuraLinkComponent,
  OwnersComponent,
  FaqsComponent,
  MyAccountComponent,
  ProfileComponent,
  PaymentComponent,
];
